import { parse,stringify } from 'qs';
import { isArray, pick, map, isNumber, cloneDeep, assign, isObject, get } from 'lodash';
import Moment from 'moment';
import Config from 'config/Config';
import Language from 'config/langs';

class Utils {
  // 从url取值 name可以参数的key，或者多个key的数组
  static getQueryString(name) {
    let after = window.location.hash.split('?')[1] || '';
    if(!after || !name){
      return null;
    }

    if(isArray(name)){
      // 去空格
      let obj = parse(after.trim());
      // 每一项都解码
      map(obj, (v) => {
        return decodeURIComponent(v);
      })
      return pick(obj, name);
    }

    let reg = new RegExp('(^|&)' + name.trim() + '=([^&]*)(&|$)');
    let r = after.trim().match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  }
  //多时区
  /*
  * dateString  只支持  2019-05-28 15:11:19 时间格式 或者  1559027246000  时间戳格式
  * */
  static timeZone(dateString,format='YYYY-MM-DD HH:mm:ss'){
    let timeObj = {
      timeStamp:"", //时间戳
      utcTime:"", //utc时间
      utcTimeStamp:"", // utc时间戳
      timeZone:"", //当前时区
      currentZoneTime:"", //当前时区的时间
      time:"",//时间戳直接转为时间
    };
    if(!dateString) return timeObj;

    if(dateString.indexOf("-") > -1 && dateString.length == 10){
      dateString += " 00";
    }

    //如果不开启时区效果， 则取消时区转换功能
    if(!Config.isTimeZone){
      timeObj.utcTime = dateString;
      timeObj.currentZoneTime = dateString;
      return timeObj;
    }

    if(String(dateString).length == 10) dateString = dateString * 1000;
    //转为时间戳
    timeObj.timeStamp = Date.parse(dateString);
    timeObj.utcTime = Moment.utc(timeObj.timeStamp).format(format);
    timeObj.timeZone = new Date().getTimezoneOffset() / 60; //获取时区
    //当前时区时间等于 UTC时间加上时区偏差
    timeObj.currentZoneTime = Moment(dateString).subtract(timeObj.timeZone,'hour').format(format);
    timeObj.time = Moment(dateString).format(format);
    return timeObj;
  }

  static timeFormat(dateString){
    var now = dateString;
    if(isNumber(dateString)){
      now = new Date(dateString)
    }
    var year = now.getFullYear();       //年
    var month = now.getMonth() + 1;     //月
    var day = now.getDate();            //日
    var hh = now.getHours();            //时
    var mm = now.getMinutes();          //分
    var ss = now.getSeconds();          //分
    var clock = year + "-";       
    if(month < 10){
      clock += "0";       
    }
    clock += month + "-";  
    if(day < 10){
      clock += "0";        
    }
    clock += day + " "; 
    if(hh < 10){
      clock += "0";           
    }
    clock += hh + ":";
    if (mm < 10) {
      clock += '0'
    } 
    clock += mm + ':'; 
    if (ss < 10) {
      clock += '0'
    } 
    clock += ss
    return(clock); 
  }
  /*
  *  千分位组件，传入金额，返回千分位数字
   * number {number} 需要格式化的数字 默认0
   * precision {number} 需要保留的小数位，默认0
   * prefix {string} 是否需要加金额前缀，默认false
  * */
  static numberFormat({ number = 0, precision = 0, prefix = false }) {
    let isPlus = true;
    if (String(number).indexOf('-') > -1) {
      isPlus = false;
      number = Number(String(number).replace(/-/g, ''));
    }
    let displayPrefix = prefix ? prefix : '';
    number = String(number).replace(/(^\s*)|(\s*$)/g, "");
    if (isNaN(number) || !number) {
      return displayPrefix + parseFloat(0).toFixed(precision);
    } else {
      number = parseFloat(number).toFixed(precision)
    }
    number = number + '';
    if (number) {
      let nums = number.split('.')
      let num = nums[0].slice(nums[0].length % 3)
      let numBegin = nums[0].slice(0, nums[0].length % 3)
      number = numBegin + ((numBegin && num) ? ',' : '') + (num ? num.match(/\d{3}/g).join(',') : '') + (nums[1] ? '.' + nums[1] : '')
    }
    if (!isPlus) {
      number = '-' + number;
    }
    return displayPrefix + number;
  }

  /*
  *  格式化listpage组件的参数，查询参数filter
   * data {} 组件原本的参数格式
   * searchParamList [] 查询条件的内容
  * */
  static formatParams(data,searchParamList){
    console.log(data,searchParamList)
    let cloneData = cloneDeep(data);
    cloneData.filters = [];
    searchParamList&&searchParamList.map((item) => {
      if(cloneData.hasOwnProperty(item.property) && cloneData[item.property]){
        item.value = cloneData[item.property];
        delete cloneData[item.property]
        cloneData.filters.push(item);
      }
    })
    // cloneData.filters=JSON.stringify(cloneData.filters)
    console.log('查询信息===='+cloneData.filters)
    delete cloneData.pageSize
    delete cloneData.pageNum
    // if(cloneData.filters.length ==  0) delete cloneData.filters;
    console.log(cloneData.filters,'===',stringify(cloneData.filters),
    '1');
    let newData = {
      filter:{
        filters:cloneData.filters
      },
      pageSize: data.pageSize,
      pageNum: data.pageNum
    }
    console.log(newData,'newData');
    return newData
  }

  /**
   * 
   */
  static listGet(item,id,name) {
    for(let i = 0;i< item.length;i++) {
      // console.log(item);
      item[i].key = item[i][id];
      item[i].label = item[i][name];
      if(item[i].children!==undefined&&item[i].children!==[]&&item[i].children!==null) {
        // console.log(12313)
        this.listGet(item[i].children,id,name)
      }
    }
  }
  static deleteArrVal(val,arr){
    for(var i = 0; i < arr.length; i++){
     if(arr[i] == val){ 
        let a = arr.splice(i,1);
        return a;
    }
   }
   return -1;
  }
  // list转tree
  static buildTree(list, keyName, pkeyName, isRoot) {
      const maps = {};
      const rooList = [];
      list.map((item, i) => {
          if (!item[pkeyName] || isRoot(item)) {
              rooList.push(item);
          }
          else {
              let cList = maps[item[pkeyName]];
              if (!cList) {
                  maps[item[pkeyName]] = cList = [];
              }
              cList.push(item);
          }
      });
      // console.log(202,'maps',maps,'rooList',rooList)
      const tree = this.mapToTree(rooList, maps, keyName);
      return tree;
  }
  static mapToTree(list, maps, keyName) {
        const tree = [];
        list.map((item, i) => {
            const nItem = assign({}, item);
            tree.push(nItem);
            const children = maps[item[keyName]];
            if (children)
                nItem.children = this.mapToTree(children, maps, keyName);
        });
        return tree; //
  }
  static getTreeParents(list,val){
    let arr = []
    list.forEach(item=>{
      if(item.children){
        item.children.forEach(item2=>{
          item2.id == val
          arr.push(item.id)
        })
      }
    })
  }
  static language(obj) {
    // console.log(obj,111111111);
    let val = isObject(obj) ? get(language, get(obj, 'name'), '') : get(Language, obj, '');
    let values = get(obj, 'values',"");
    //填充字符串模版
    if(values && isObject(values)){
      val = this.strFormat(val, get(obj, 'values',{}))
    }
    return val;
  }
}
export default Utils;



// WEBPACK FOOTER //
// ./src/utils/index.js